export const EXPIRED_ERROR = 'Token has expired';
